import escapeRegex from './escape-regex';

/*
 * This function is responsible for:
 *  - Splitting review/response content up into paragraphs.
 *  - Adding highlighting around search terms.
 *  - Returns an HTML string.
 */
const makeRenderContent = (query: string | null | undefined) => {
    const renderContent = (content: string, shouldUseSeparateParagraphs = true): string => {
        let lines: string[] = content.split(/\n+/);
        if (query) {
            const queryWords = query.split(/\s+/);
            const queryRegExp = RegExp(queryWords.map(escapeRegex).join('|'), 'gi');
            lines = lines.map((line) => {
                const parts: string[] = [];
                queryRegExp.lastIndex = 0;
                let lastIndex = 0;
                while (true) {
                    const match = queryRegExp.exec(line);
                    if (!match) {
                        parts.push(line.substring(lastIndex));
                        break;
                    }
                    parts.push(line.substring(lastIndex, match.index));
                    parts.push(`<strong>${match[0]}</strong>`);
                    lastIndex = queryRegExp.lastIndex;
                }
                return parts.join('');
            });
        }
        if (shouldUseSeparateParagraphs) {
            return lines.map((line: string) => `<p>${line}</p>`).join('');
        }
        return lines.map((line: string) => `<span>${line}</span>`).join('');
    };
    return renderContent;
};

export default makeRenderContent;
